// src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDocRef = doc(db, 'employees', user.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          const roleIds = userData.roles || [];

          const rolePromises = roleIds.map(roleId => getDoc(doc(db, 'roles', roleId)));
          const roleDocs = await Promise.all(rolePromises);

          const mergedPermissions = roleDocs.reduce((acc, roleDoc) => {
            if (roleDoc.exists()) {
              return { ...acc, ...roleDoc.data().permissions };
            }
            return acc;
          }, {});

          const roleNames = roleDocs.map(roleDoc => 
            roleDoc.exists() ? roleDoc.data().name : null
          ).filter(Boolean);

          setCurrentUser({
            ...user,
            ...userData,
            permissions: mergedPermissions,
            roleNames: roleNames,
          });

        } else {
          setCurrentUser({ ...user, permissions: {}, roleNames: [] }); 
        }
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = { currentUser, loading };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}